import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext';

// Page Components
import Login from './pages/Login';
import Main from './pages/Main';
import TeacherDashboard from './pages/TeacherDashboard';
import StudentRegistration from './pages/StudentRegistration';
import BookRegistration from './pages/BookRegistration';
import OverallStatus from './pages/OverallStatus';
import ReadingRegistration from './pages/ReadingRegistration';
import ReadingLog from './pages/ReadingLog';
import StatusBoard from './pages/StatusBoard';
import StudentLogDetail from './pages/StudentLogDetail';
import StudentManagement from './pages/StudentManagement';

// Route Protection Components
import ProtectedRoute from './components/ProtectedRoute';
import TeacherRoute from './components/TeacherRoute';


// A component to redirect logged-in users from the login page
const RedirectIfLoggedIn = ({ children }) => {
    const { user, loading } = useAuth();
    if (loading) return <div>Loading...</div>;
    return user ? <Navigate to="/main" /> : children;
};


function App() {
    return (
        <Router>
            <Routes>
                <Route 
                    path="/" 
                    element={
                        <RedirectIfLoggedIn>
                            <Login />
                        </RedirectIfLoggedIn>
                    } 
                />

                {/* Authenticated Routes */}
                <Route element={<ProtectedRoute />}>
                    <Route path="/main" element={<Main />} />
                    
                    {/* Student Routes */}
                    <Route path="/student/reading-registration" element={<ReadingRegistration />} />
                    <Route path="/student/reading-log" element={<ReadingLog />} />
                    <Route path="/student/status-board" element={<StatusBoard />} />

                    {/* Teacher Routes */}
                    <Route element={<TeacherRoute />}>
                        <Route path="/teacher" element={<TeacherDashboard />} />
                        <Route path="/teacher/student-registration" element={<StudentRegistration />} />
                        <Route path="/teacher/book-registration" element={<BookRegistration />} />
                        <Route path="/teacher/overall-status" element={<OverallStatus />} />
                        <Route path="/teacher/student-log/:studentId" element={<StudentLogDetail />} />
                        <Route path="/teacher/student-management" element={<StudentManagement />} />
                    </Route>
                </Route>
                
                {/* Fallback Route */}
                <Route path="*" element={<Navigate to="/" />} />
            </Routes>
        </Router>
    );
}

export default App;